import { render, staticRenderFns } from "./DeclarationOfConformity.vue?vue&type=template&id=0d6a204d&"
import script from "./DeclarationOfConformity.vue?vue&type=script&lang=js&"
export * from "./DeclarationOfConformity.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationOfConformity.vue?vue&type=style&index=0&id=0d6a204d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports